<div ng-controller="purgeDocumentsViaTagsController as ctrl" class="modal-view purge-documents">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>